export default __webpack_public_path__ + "static/healty-all-548774068bf76c5bae272f953c5a6603.png";